<div class="message-area">
  <div class="fxf-auto-fill-r fxl-column fxla-space-between-stretch-mw fxg-col-5px">
    @for (note of data.notes; track $index) {
      <div>
        <app-note [note]="note"></app-note>
      </div>
    }
    @if (hasAction) {
      <a (click)="performAction()" [class.external-link]="data.actionExternalLinkFlag" class="action-link primary-fg fxsa-center">
        {{ data.actionLabel }}
      </a>
    }
  </div>
  <button (click)="close()" class="ml-4 small-icon-button" mat-icon-button>
    <mat-icon class="s-16">close</mat-icon>
  </button>
</div>
